import { Alert } from '@mantine/core';
import { IconSparkles } from '@tabler/icons-react';

const AiDraftNotice = () => (
  <Alert color="blue" icon={<IconSparkles size={16} />} mb="md">
    Prepared by the AI assistant. Review it here, then approve it from AI proposals or start it as usual.
  </Alert>
);

export default AiDraftNotice;
